var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMotorDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.59994,
    y: 1.6,
    width: 16.8,
    height: 16.8,
    rx: 1.4,
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99994,
    cy: 10,
    r: 5.4,
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57568 9.57574C9.34136 9.81005 9.34136 10.1899 9.57568 10.4243C9.80999 10.6586 10.1899 10.6586 10.4242 10.4243L9.57568 9.57574ZM13.5757 5.57574L9.57568 9.57574L10.4242 10.4243L14.4242 6.42426L13.5757 5.57574Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMotorDrive);
export default __webpack_public_path__ + "static/media/icon-motor-drive.3cb857285f7aecaa6d41b8e84841be98.svg";
export { ForwardRef as ReactComponent };